import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ClueManage/Update?userId=" +
      userData.userId(),
    params
  );
};

const updateComment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ClueManage/UpdateComment?userId=" +
      userData.userId(),
    params
  );
};

const deleteItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ClueManage/Delete?userId=" +
      userData.userId(),
    params
  );
};

const getClueTrackingNull = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ClueManage/ClueTrackingNull",
    params
  );
};

const addTrackingScreening = (params) =>
  axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ClueManage/AddTrackingScreening?userId=" +
      userData.userId(),
    params
  );

export {
  updateItem,
  updateComment,
  deleteItem,
  getClueTrackingNull,
  addTrackingScreening,
};
